export default __webpack_public_path__ + "static/wholesalersVp1-ab95b27f83fdd98154ac66c41e642a5d.png";